import { AuthenticatedUser } from "../../";
import { ActionsUnion, createAction } from "../reducer/actionHelpers";
import { TeamPlanFeatures } from "./teamPlanFeatures";

export enum actionName {
    API_CALL_SUCCESSFUL = "API_CALL_SUCCESSFUL",
    API_CALL_FAILURE = "API_CALL_FAILURE",
    APP_OFFLINE = "APP_OFFLINE",
    APP_ONLINE = "APP_ONLINE",
    SET_CURRENT_USER = "SET_CURRENT_USER",
    SET_TEAM_PLAN_FEATURES = "SET_TEAM_PLAN_FEATURES",
    OPEN_MENU = "OPEN_MENU",
    CLOSE_MENU = "CLOSE_MENU",
    TOGGLE_MENU = "TOGGLE_MENU",
}

export const creators = {
    apiCallSuccessful: () => createAction(actionName.API_CALL_SUCCESSFUL),
    apiCallFailure: () => createAction(actionName.API_CALL_FAILURE),
    appOffline: () => createAction(actionName.APP_OFFLINE),
    appOnline: () => createAction(actionName.APP_ONLINE),
    setCurrentUser: (user: AuthenticatedUser) =>
        createAction(actionName.SET_CURRENT_USER, { user }),
    setTeamPlanFeatures: (teamPlanFeatures: TeamPlanFeatures) =>
        createAction(actionName.SET_TEAM_PLAN_FEATURES, { teamPlanFeatures }),
    openMenu: () => createAction(actionName.OPEN_MENU),
    closeMenu: () => createAction(actionName.CLOSE_MENU),
    toggleMenu: () => createAction(actionName.TOGGLE_MENU),
};

export type RelodeAppActionTypes = ActionsUnion<typeof creators>;
